module.exports = __webpack_public_path__ + "assets/img/driver-btn-a210334c.png";